export const arcanaCards = [
    {
        id: 1,
        name: '01 - The Fool',
    },
    {
        id: 2,
        name: '02 - The Magician',
    },
    {
        id: 3,
        name: '03 - The High Priestess',
    },
    {
        id: 4,
        name: '04 - The Empress',
    },
    {
        id: 5,
        name: '05 - The Emperor',
    },
    {
        id: 6,
        name: '06 - The Hierophant',
    },
    {
        id: 7,
        name: '07 - The Lovers',
    },
    {
        id: 8,
        name: '08 - The Chariot',
    },
    {
        id: 9,
        name: '09 - Strength',
    },
    {
        id: 10,
        name: '10 - The Hermit',
    },
    {
        id: 11,
        name: '11 - Wheel of Fortune',
    },
    {
        id: 12,
        name: '12 - Justice',
    },
    {
        id: 13,
        name: '13 - The Hanged Man',
    },
    {
        id: 14,
        name: '14 - Death',
    },
    {
        id: 15,
        name: '15 - Temperance',
    },
    {
        id: 16,
        name: '16 - The Devil',
    },
    {
        id: 17,
        name: '17 - The Tower',
    },
    {
        id: 18,
        name: '18 - The Star',
    },
    {
        id: 19,
        name: '19 - The Moon',
    },
    {
        id: 20,
        name: '20 - The Sun',
    },
    {
        id: 21,
        name: '21 - Judgement',
    },
    {
        id: 22,
        name: '22 - The World',
    },
    {
        id: 23,
        name: '23 - Echo',
    },
    {
        id: 24,
        name: '24 - Rebirth',
    },
];
